import EdverumTable from '@/store/utilities/EdverumTable.js';

const collectionHelpers = EdverumTable.collection('video');

export default {
    state: {
        ...EdverumTable.search.state,
        ...EdverumTable.created.state,
        ...EdverumTable.searchTag.state,
        ...EdverumTable.searchGroup.state,
        ...EdverumTable.searchCourseCode.state,
        ...EdverumTable.searchInstructor.state,
        ...EdverumTable.viewArchived.state,
    },

    getters: {
        ...EdverumTable.search.getters,
        ...EdverumTable.searchTag.getters,
        ...EdverumTable.searchGroup.getters,
        ...EdverumTable.searchCourseCode.getters,
        ...EdverumTable.searchInstructor.getters,
        ...collectionHelpers.getters,
        ...EdverumTable.viewArchived.getters,
    },

    actions: {
        ...EdverumTable.created.actions,

        fetchAssignableTags: EdverumTable.searchTag.actions.fetchAssignableTags('/api/tags?type=video'),
        fetchAssignableGroups: collectionHelpers.actions.fetchAssignableGroups(),

        reset: collectionHelpers.actions.reset('Videos'),
    },

    mutations: {
        ...EdverumTable.search.mutations,
        ...EdverumTable.created.mutations,
        ...EdverumTable.searchTag.mutations,
        ...EdverumTable.searchGroup.mutations,
        ...EdverumTable.searchCourseCode.mutations,
        ...EdverumTable.searchInstructor.mutations,
        SET_ASSIGNABLE_GROUPS: collectionHelpers.mutations.SET_ASSIGNABLE_GROUPS,
    },
};
